import React from 'react'

import classNames from 'classnames'

const Alert = ({ children, variant, className, ...rest }) => (
  <div className={classNames('alert', `alert-${variant}`, className)} {...rest}>{children}</div>
)

export default Alert
